<template>
  <div>
    <div v-popover="{ name: tooltipId, position: position }">
      <button
        class="d-flex tooltip-popover align-items-center justify-content-center"
        :class="{
          'regular-popover': tooltipType === 'regular',
          'deal-banner-popover': tooltipType === 'deal_banner',
        }"
      >
        ?
      </button>
    </div>
    <client-only>
      <v-popover
        :name="tooltipId"
        event="hover"
        transition="fade"
        :pointer="false"
      >
        {{ tooltipText }}
      </v-popover>
    </client-only>
  </div>
</template>

<script>
export default {
  name: 'TooltipIcon',
  props: {
    tooltipId: {
      type: String, // must be unique to prevent multiple tooltips appearing on click/hover
      required: true,
    },
    tooltipText: {
      type: String,
      required: true,
    },
    tooltipType: {
      type: String,
      default: 'regular',
      validator(tooltipType) {
        return ['regular', 'deal_banner'].includes(tooltipType);
      },
    },
    position: {
      type: String,
      default: 'bottom',
      validator(pos) {
        return ['top', 'right', 'bottom', 'left'].includes(pos);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/dorado/themes/dorado';

  [data-popover] {
    border-radius: 4px;
    color: #fff;
    padding: 15px;
    font-size: 12px;
    max-width: 200px !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: $forest !important;
    margin-top: 6px;
    text-align: center;
    z-index: 1020 !important; /* Overlay over the mobile buy header */
  }

  .tooltip-popover {
    border: 0;
    border-radius: 50%;
    font-size: 17px;
    height: 16px;
    padding: 0; // override iOS default user-agent values
    width: 16px;
  }

  .regular-popover {
    background-color: $bolt;
    color: #fff;
  }

  .deal-banner-popover {
    background-color: $black-pearl;
    color: $ready-red;
  }
</style>
